import { render } from "./TvmSlideOutKbbTradeValue.vue?vue&type=template&id=60c9a1f8&scoped=true"
import script from "./TvmSlideOutKbbTradeValue.vue?vue&type=script&lang=js"
export * from "./TvmSlideOutKbbTradeValue.vue?vue&type=script&lang=js"

import "./TvmSlideOutKbbTradeValue.vue?vue&type=style&index=0&id=60c9a1f8&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c9a1f8"],['__file',"src/components/ChatWidget/SlideOutPanel/TvmSlideOutKbbTradeValue/TvmSlideOutKbbTradeValue.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60c9a1f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60c9a1f8', __exports__)) {
    api.reload('60c9a1f8', __exports__)
  }
  
  module.hot.accept("./TvmSlideOutKbbTradeValue.vue?vue&type=template&id=60c9a1f8&scoped=true", () => {
    api.rerender('60c9a1f8', render)
  })

}


export default __exports__